import Pendo from './pendo';

/**
 * Helper utility for tracking Pendo events with built-in error handling
 */
const pendoHelper = {
  /**
   * Track a Pendo event with error handling
   *
   * @param eventName - The name of the Pendo event to track
   * @param eventData - Optional object containing event properties to track
   */
  trackEvent: (eventName: string, eventData?: Record<string, any>): void => {
    try {
      if (eventData) {
        Pendo.track(eventName, eventData);
      } else {
        Pendo.track(eventName);
      }
    } catch (error) {
      console.error('Error in pendo tracking:', error);
    }
  },
};

export default pendoHelper;
